module.exports = __webpack_public_path__ + "static/media/RectangleDr.914ce11f.png";